import React from "react"

import RichText from "../RichText"
import Copy from "../Copy/Copy"
import Button from "../Button/Button"
import Media from "../Media/Media"
import Video from "../Video/Video"

import { ColumnComponents, ColumnsModule } from "../../models/modules"
import {
  ButtonModel,
  CopyModel,
  MediaModel,
  VideoModel,
} from "../../models/components"

interface Props extends ColumnsModule {
  cssClass?: string
  pageContext: any
}

const defaultProps = {}

export const Columns: React.FC<Props> = props => {
  return (
    <div className="grid-container columns">
      <div className="grid-x grid-margin-x">
        <div
          className={`cell large-6 col--1 ${
            props.separator ? "separator" : ""
          }`}
        >
          <div
            className={`${
              props.column_1_promo_links ? "promoCard__wrapper--button" : ""
            }`}
          >
            <RichText
              content={props.col_1_text}
              cssClass="content"
              pageContext={props.pageContext}
            />
          </div>
          <RenderColumnComponents
            items={props.col_1_components}
            pageContext={props.pageContext}
          />
        </div>
        <div className="cell large-6 col--2">
          <div
            className={`${
              props.column_2_promo_links ? "promoCard__wrapper--button" : ""
            }`}
          >
            <RichText
              content={props.col_2_text}
              cssClass="content"
              pageContext={props.pageContext}
            />
          </div>
          <RenderColumnComponents
            items={props.col_2_components}
            pageContext={props.pageContext}
          />
        </div>
      </div>
    </div>
  )
}

Columns.defaultProps = defaultProps

export default Columns

interface RenderProps {
  items?: ColumnComponents[]
  pageContext: any
}

const RenderColumnComponents: React.FC<RenderProps> = props => {
  if (!props.items || props.items.length === 0) return null

  return (
    <>
      {props.items?.map(item => {
        if (item?.internal?.type === "Contentstack_button")
          return (
            <div key={item.id} className="embed text-center">
              <Button
                {...(item as ButtonModel)}
                pageContext={props.pageContext}
              />
            </div>
          )

        if (item?.internal?.type === "Contentstack_copy")
          return (
            <Copy
              key={item.id}
              {...(item as CopyModel)}
              pageContext={props.pageContext}
            />
          )

        if (item?.internal?.type === "Contentstack_media")
          return (
            <Media
              key={item.id}
              {...(item as MediaModel)}
              pageContext={props.pageContext}
            />
          )

        if (item?.internal?.type === "Contentstack_video")
          return (
            <Video
              key={item.id}
              {...(item as VideoModel)}
              pageContext={props.pageContext}
            />
          )
      })}
    </>
  )
}
